module.exports = __webpack_public_path__ + "img/card.18ba22cb.jpg";